import React from 'react';
import { AutoSuggestField } from '../../../../../shared/components/auto-suggest/AutoSuggestField';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { UNITED_STATES } from '../../../../domain/united-states/domain/constants/UnitedStates';
import { getStateAbbreviationForName } from '../../../../domain/united-states/domain/use-cases/getStateAbbreviationForName';

const US_STATE_DROPDOWN_ITEMS = UNITED_STATES.map((state) => state.name);

interface IStateProps {
	hint?: string;
}

export const State = ({ hint }: IStateProps) => {
	const { t } = useTranslation();

	return (
		<AutoSuggestField
			name="state"
			label={t('parking_details_form_state_label')}
			placeholder={t('parking_details_form_state_placeholder')}
			items={US_STATE_DROPDOWN_ITEMS}
			filter={filterStateDropdownItems}
			required
			hint={hint}
		/>
	);
};

function filterStateDropdownItems(name: string, inputValue?: string) {
	if (!inputValue) {
		return true;
	}

	const inputValueLowerCase = inputValue.toLowerCase();

	if (name.toLowerCase().startsWith(inputValueLowerCase)) {
		return true;
	}

	const abbreviation = getStateAbbreviationForName(name);

	return abbreviation?.toLowerCase().startsWith(inputValueLowerCase) ?? false;
}
